import styled from 'styled-components';

export const ReviewsSliderContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

export const ReviewsTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #000;
  margin-bottom: 12px;

  @media (prefers-color-scheme: dark) {
    color: #fff;
  }
`;

export const ReviewsSliderWrapper = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  direction: ltr;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  padding: 12px calc(50% - 140px);

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ReviewCard = styled.div`
  flex-shrink: 0;
  width: 280px;
  min-width: 280px;
  background-color: #fff;
  border-radius: 8px;
  padding: 16px 24px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.01), 0 4px 12px 0 rgba(0, 0, 0, 0.08),
    0 8px 24px 0 rgba(0, 0, 0, 0.015);
  scroll-snap-align: center;
  gap: 14px;
  display: flex;
  flex-direction: column;

  @media (prefers-color-scheme: dark) {
    background-color: #262626;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.08),
      0 4px 12px 0 rgba(0, 0, 0, 0.12), 0 8px 24px 0 rgba(0, 0, 0, 0.06);
  }
`;

export const ReviewTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 21px;
  color: #000;

  @media (prefers-color-scheme: dark) {
    color: #fff;
  }
`;

export const ReviewRating = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ReviewAuthor = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #8e8e93;
`;

export const ReviewText = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #5e5e5e;

  @media (prefers-color-scheme: dark) {
    color: #cecece;
  }
`;
